var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 3C10.1022 3.00001 9.24113 3.37733 8.60623 4.04898C7.97133 4.72062 7.61464 5.63156 7.61463 6.58141C7.61463 7.05173 7.70219 7.51746 7.87233 7.95198C8.04246 8.38651 8.29183 8.78132 8.6062 9.11389C8.92057 9.44647 9.29379 9.71028 9.70454 9.89027C10.1153 10.0703 10.5555 10.1629 11.0001 10.1629C11.4447 10.1629 11.885 10.0703 12.2957 9.89029C12.7065 9.71031 13.0797 9.4465 13.3941 9.11393C13.7085 8.78135 13.9578 8.38653 14.1279 7.952C14.2981 7.51747 14.3857 7.05174 14.3856 6.58141C14.3856 6.11108 14.2981 5.64537 14.1279 5.21085C13.9578 4.77633 13.7085 4.38151 13.3941 4.04895C13.0797 3.71638 12.7064 3.45258 12.2957 3.2726C11.885 3.09262 11.4447 2.99999 11.0001 3ZM11.0001 11.6125C9.14654 11.6127 7.36867 12.3906 6.05642 13.7754C4.74416 15.1603 4.00463 17.0391 4 19H18C17.9954 17.0392 17.2559 15.1604 15.9437 13.7755C14.6314 12.3907 12.8537 11.6128 11.0001 11.6125Z",
    fill: "#4A4A4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestIcon);
export default __webpack_public_path__ + "static/media/guestIcon.fef47615f4a40ff8825435184ba1b974.svg";
export { ForwardRef as ReactComponent };